import { cn } from "../../utils/classnames.js";
import { jsx } from "react/jsx-runtime";
import { Menu } from "@base-ui/react/menu";
// src/components/atoms/dropdown-menu.tsx
const DropdownMenu = ({ ...props }) => {
	return /* @__PURE__ */ jsx(Menu.Root, {
		"data-slot": "dropdown-menu",
		...props
	});
};
const DropdownMenuPortal = ({ ...props }) => {
	return /* @__PURE__ */ jsx(Menu.Portal, {
		"data-slot": "dropdown-menu-portal",
		...props
	});
};
const DropdownMenuBackdrop = ({ className, ...props }) => {
	return /* @__PURE__ */ jsx(Menu.Backdrop, {
		className: cn(`
          inset-0 bg-black/32 absolute z-50 transition-opacity duration-450
          ease-[cubic-bezier(0.32,0.72,0,1)]
          data-[ending-style]:opacity-0
          data-[starting-style]:opacity-0
        `, className),
		"data-slot": "dropdown-menu-backdrop",
		...props
	});
};
const DropdownMenuTrigger = ({ ...props }) => {
	return /* @__PURE__ */ jsx(Menu.Trigger, {
		"data-slot": "dropdown-menu-trigger",
		...props
	});
};
const DropdownMenuGroup = ({ className, ...props }) => {
	return /* @__PURE__ */ jsx(Menu.Group, {
		"data-slot": "dropdown-menu-group",
		className: cn("gap-1 flex flex-col", className),
		...props
	});
};
const DropdownMenuItem = ({ nativeButton: isNativeButton = true, inset, variant = "default", className, ...props }) => {
	return /* @__PURE__ */ jsx(Menu.Item, {
		nativeButton: isNativeButton,
		className: cn(`
          focus:bg-muted focus:text-primary-text
          font-medium
          data-[variant=destructive]:text-destructive-foreground
          data-[variant=destructive]:focus:bg-destructive/10
          data-[variant=destructive]:focus:text-destructive-foreground
          [&[data-variant=destructive]_svg]:text-destructive-foreground
          [&_svg:not-[class*='text-']]:text-muted-foreground
          gap-2 rounded-md px-2 py-2 text-sm
          data-[inset]:pl-8
          [&_svg:not-[class*='size-']]:size-4
          relative flex w-full cursor-pointer items-center outline-hidden transition-none
          select-none
          data-disabled:pointer-events-none data-disabled:opacity-50
          [&_svg]:pointer-events-none [&_svg]:shrink-0
        `, className),
		"data-slot": "dropdown-menu-item",
		"data-inset": inset,
		"data-variant": variant,
		...props
	});
};
const DropdownMenuRadioGroup = ({ ...props }) => {
	return /* @__PURE__ */ jsx(Menu.RadioGroup, {
		"data-slot": "dropdown-menu-radio-group",
		...props
	});
};
const DropdownMenuLabel = ({ className, inset, ...props }) => {
	return /* @__PURE__ */ jsx(Menu.GroupLabel, {
		"data-slot": "dropdown-menu-label",
		"data-inset": inset,
		className: cn("px-2 py-1.5 text-sm font-medium data-[inset]:pl-8", className),
		...props
	});
};
const DropdownMenuSeparator = ({ className, ...props }) => {
	return /* @__PURE__ */ jsx(Menu.Separator, {
		"data-slot": "dropdown-menu-separator",
		className: cn("bg-border -mx-1 my-1 h-px", className),
		...props
	});
};
const DropdownMenuShortcut = ({ className, ...props }) => {
	return /* @__PURE__ */ jsx("span", {
		"data-slot": "dropdown-menu-shortcut",
		className: cn("text-muted-foreground text-xs tracking-widest ml-auto", className),
		...props
	});
};
const DropdownMenuSub = ({ ...props }) => {
	return /* @__PURE__ */ jsx(Menu.SubmenuRoot, {
		"data-slot": "dropdown-menu-sub",
		...props
	});
};
export { DropdownMenu, DropdownMenuBackdrop, DropdownMenuGroup, DropdownMenuItem, DropdownMenuLabel, DropdownMenuPortal, DropdownMenuRadioGroup, DropdownMenuSeparator, DropdownMenuShortcut, DropdownMenuSub, DropdownMenuTrigger };

//# sourceMappingURL=dropdown-menu.js.map